import React, { useState } from 'react';
import { UploadApi } from '../../../api/adminApi';
import './ImageUploader.css';

const ImageUploader = ({ value, onChange, helperText }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = async (event) => {
    const input = event.target;
    const file = input.files?.[0];
    if (!file) return;

    setUploading(true);
    setError('');
    try {
      const { url } = await UploadApi.uploadImage(file);
      onChange(url);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Upload failed');
    } finally {
      setUploading(false);
      input.value = '';
    }
  };

  return (
    <div className="image-uploader">
      {value && (
        <div className="image-preview">
          <img src={value} alt="Uploaded" />
        </div>
      )}
      <div className="image-actions">
        <label className="upload-btn">
          {uploading ? 'Uploading…' : value ? 'Replace image' : 'Select image'}
          <input type="file" accept="image/*" onChange={handleFileChange} disabled={uploading} />
        </label>
        {value && !uploading && (
          <button type="button" className="clear-btn" onClick={() => onChange('')}>
            Remove
          </button>
        )}
      </div>
      {helperText && <p className="helper-text">{helperText}</p>}
      {error && <p className="error-text">{error}</p>}
    </div>
  );
};

export default ImageUploader;
